import { EmployeesService } from '../../services/employees.service';
import { IShift, ShiftService } from '../../services/shifts.service';
import { ILocation, LocationService } from '../../services/location.service';
import * as moment from 'moment';
import { AuthService } from "../../authorization/services/index";


class ScheduleItemController implements ng.IComponentController {
    private location: ILocation;
    private onChange: any;
    private employeeSummary: any;
    private shift: IShift;

    constructor(
        private ShiftService: ShiftService,
        private EmployeesService: EmployeesService,
        private $stateParams: ng.ui.IStateParamsService,
        private LocationService: LocationService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        if (this.$stateParams['id']) {
            this.getShift();
        }

        if(this.$stateParams['id']) {
            this.onChange({type: 'init', data: this.$stateParams['id'] });
        }
    } 
    
    public getShift = () => {
        this.ShiftService.get(this.$stateParams['id']).then((shift) => {
            this.shift = shift;
            this.EmployeesService.customAll('employeeSummary', {from: moment(this.shift.start).subtract(1, 'h').toDate(), till: moment(this.shift.start).add(1, 'h').toDate()}).then((employeeSummary: any) => {
                this.employeeSummary = employeeSummary[0];
            });
            this.LocationService.get(this.shift.teamLocationId).then((location) => {
                this.location = location;
            })
        })
    }
    
}

export const scheduleItemComponent: ng.IComponentOptions = {
    bindings: {
        // shift: '<',
        // employees: '<',
        // statuses: '<',
        // accounts: '<',
        // functions: '<',
        onChange: '&',
    },
    controller: ScheduleItemController,
    template: <string>require('./schedule.item.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/schedule/schedule.item.component.ts